import { ShieldAlertIcon } from "lucide-react";
import type { ReactNode } from "react";

interface ContentRemovedBadgeProps {
  body?: string;
  children?: ReactNode;
}

export function ContentRemovedBadge({ body, children }: ContentRemovedBadgeProps) {
  return (
    <div className="mx-auto flex max-w-sm flex-col items-center gap-2 rounded-2xl bg-zinc-50 px-4 py-3 text-center">
      <ShieldAlertIcon className="h-5 w-5 text-zinc-400" />
      <p className="text-sm font-medium text-zinc-700">Content removed</p>
      {body && <p className="text-xs text-zinc-500">{body}</p>}
      {children}
    </div>
  );
}
